import {gql} from "@apollo/client";
import {mutate, query} from "../../lib/apollo";

const FIELD_ROW = `
    hpPostEventFieldId
    postFieldName
    fieldTypeId
    dbFieldNameId
    databaseMapId
    randomId
    fixedText
    otherFunctionId
    sort
`;

export async function fetchHpEventFieldsDetail(
    hpPostEventId: number,
    hpPostEventIdCopy?: number | null
) {
    const q = gql`
        query ($hpPostEventId: Int!, $hpPostEventIdCopy: Int) {
            hpEventFieldsDetail(hpPostEventId: $hpPostEventId, hpPostEventIdCopy: $hpPostEventIdCopy) {
                hpPostEventId
                rows {
                    ${FIELD_ROW}
                }
            }
        }
    `;
    const res = await query(q, {
        hpPostEventId,
        hpPostEventIdCopy: hpPostEventIdCopy || null,
    });
    return res?.hpEventFieldsDetail || null;
}

export async function fetchHpEventFieldsLookups() {
    const q = gql`
        query {
            hpEventFieldsLookups {
                dbFields {
                    id
                    label
                }
                otherFunctions {
                    id
                    label
                }
                mapIds
                randomIds
            }
        }
    `;
    const res = await query(q, {});
    return res?.hpEventFieldsLookups || null;
}

export async function fetchHpDatabaseMapEntries(mapId: number) {
    const q = gql`
        query ($mapId: Int!) {
            hpDatabaseMapEntries(mapId: $mapId) {
                databaseValue
                postValue
            }
        }
    `;
    const res = await query(q, {mapId});
    return res?.hpDatabaseMapEntries || [];
}

export async function fetchHpPostEventRandomEntries(randomId: number) {
    const q = gql`
        query ($randomId: Int!) {
            hpPostEventRandomEntries(randomId: $randomId) {
                value
                weight
            }
        }
    `;
    const res = await query(q, {randomId});
    return res?.hpPostEventRandomEntries || [];
}

export async function searchHpDatabaseMaps(terms: string[], exactOnly: boolean) {
    const q = gql`
        query ($terms: [String!]!, $exactOnly: Boolean!) {
            hpDatabaseMapSearch(terms: $terms, exactOnly: $exactOnly) {
                mapId
                databaseValue
                postValue
            }
        }
    `;
    const res = await query(q, {terms, exactOnly});
    return res?.hpDatabaseMapSearch || [];
}

export async function searchHpPostEventRandoms(terms: string[], exactOnly: boolean) {
    const q = gql`
        query ($terms: [String!]!, $exactOnly: Boolean!) {
            hpPostEventRandomSearch(terms: $terms, exactOnly: $exactOnly) {
                randomId
                value
                weight
            }
        }
    `;
    const res = await query(q, {terms, exactOnly});
    return res?.hpPostEventRandomSearch || [];
}

export async function hpEventFieldsUpsert(input: {
    hpPostEventId: number;
    rows: Array<{
        postFieldName: string;
        fieldTypeId: number;
        dbFieldNameId?: number | null;
        databaseMapId?: number | null;
        mapPairs?: Array<{left: string; right: string}> | null;
        randomId?: number | null;
        randomPairs?: Array<{left: string; right: string}> | null;
        fixedText?: string | null;
        otherFunctionId?: number | null;
        sort: number;
    }>;
}) {
    const m = gql`
        mutation ($input: HpEventFieldsUpsertInput!) {
            hpEventFieldsUpsert(input: $input) {
                hpPostEventId
                rows {
                    ${FIELD_ROW}
                }
            }
        }
    `;
    const res = await mutate(m, {input});
    return res?.hpEventFieldsUpsert || null;
}

export const FIELD_TYPES = [
    {id: -1, label: ""},
    {id: 1, label: "Lead Field (Name,...)"},
    {id: 2, label: "Random"},
    {id: 3, label: "Fixed Text"},
    {id: 4, label: "Other (Date,...)"},
];

export const AGE_DOB_FIELD_IDS = new Set([19, 24, 25, 34]);
export const HS_GRAD_FIELD_ID = 33;

export function pairsFromStrings(pairs: string[]): Array<{left: string; right: string}> {
    return pairs
        .map((p) => {
            const parts = String(p).split("##");
            return {left: parts[0] ?? "", right: parts[1] ?? ""};
        })
        .filter((p) => p.left !== "" || p.right !== "");
}
